export default "__VITE_ASSET__Brrg7adn__"